import { Loader, MantineColor } from "@mantine/core";
import { Colors } from "../../Lib/data";

interface MegaLoaderProps {
  size?: number;
  color?: MantineColor;
  type?: "bars" | "oval" | "dots";
  containerStyle?: React.CSSProperties;
}
export default function MegaLoader({
  size = 40,
  type = "dots",
  containerStyle,
  color = Colors.PurplePrimary,
}: MegaLoaderProps) {
  return (
    <>
      <div
        style={containerStyle}
        className="flex-row align-center width-100 justify-center"
      >
        <Loader size={size} color={color} type={type} />
      </div>
    </>
  );
}
